import {CanActivate} from '@angular/router';
import {AuthBasedGuard} from './auth-based-guard';
import {Injectable} from '@angular/core';

@Injectable()
export class CanActivateLogin extends AuthBasedGuard implements CanActivate {

  /**
   * Check if the user is not logged to authorize the route (login route for example)
   * @returns {boolean}
   */
  canActivate() {
    if (!this.isLogged) {
      return true;
    } else {
      // noinspection JSIgnoredPromiseFromCall
      this.router.navigate(['']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routing/login-guard.ts